import React from 'react';
import { ExcelTableCellProps } from '../../TableCell';
import { observer } from 'mobx-react';
import { getDomIdByFieldKey } from '../../../../util/typeUtil';
import { WeaSelect } from 'ecCom';
import _ from 'lodash';

@observer
export default class SelectElement extends React.Component<ExcelTableCellProps, any>{
    render() {
        const { cell, form, card, className, excel } = this.props;
        const path = cell.getPath();
        const bindObj = form.$(path);
        const {quickEditStore,getDetailFormValues} = card;
        let fieldName = getDomIdByFieldKey(bindObj.path);
        const { value, viewAttr: _viewAttr, isEdit, isMandatory, options: filtedOptions } = bindObj.bind();
        let { fieldtype, options, fieldshowtypes, isdetail } = card.getFieldProps(path);
        let viewAttr = _viewAttr ? _viewAttr : (isMandatory ? 3 : (isEdit ? 2 : 1));
        if(excel.detailProps&&excel.detailProps.hasOwnProperty("isEdit")&&card.params.type == '2'){
            //如果明细表字段，设置了不可编辑已有明细,则已有明细不可编辑，但新增的明细可以编辑
            if(getDetailFormValues(form).dtl_id&&!excel.detailProps["isEdit"]){
                viewAttr = 1;
            }
        }

        let realOptions = _.isArray(filtedOptions) ? filtedOptions : options;

        realOptions = realOptions.filter(f => f.cancel != '1');
        // realOptions = realOptions.map(option => {
        //     return {
        //         ...option,
        //         selected: viewAttr == '1'? false: option.isdefault == 'y'
        //     }
        // })
        // const value1 = value ? value : WeaTools.getSelectDefaultValue(realOptions);
        const value1 = value
        let layoutProps = {};
        if (!isdetail) {
            layoutProps = {
                layout: document.getElementById("select" + fieldName),
                useSelfLayout: true
            }
        }
        //打印模式下radio框只显示选中值
        if(card.params.type == "4" && fieldtype == '3' ){
            let newfieldName = fieldName;
            if(newfieldName.indexOf('_')>-1){
                newfieldName = newfieldName.split('_')[0];
            }
            if(card.variableMap[`radioPrintText_${newfieldName}`] === true){
                fieldtype = 1;
            }
        }
        const canQuickedit = bindObj.isquickedit && viewAttr == '1';
        return (
            <div id={"select" + fieldName} className={`${canQuickedit ? 'cube-card-editformitem ':'cube-card-editformitem2'} fieldValue ${className}`} data-fieldattr={viewAttr} data-fieldmark={fieldName} 
            {...cell.cellProps}
            onClick={() => { canQuickedit && quickEditStore.lockEditFormItem(fieldName); }}
            >
                <WeaSelect
                    className={isdetail ? 'cube-detail-select cube-card-select' : 'cube-card-select'}
                    options={[{ key: '', showname: '' }, ...realOptions]}
                    fieldName={fieldName}
                    viewAttr={viewAttr}
                    detailtype={fieldtype}
                    fieldshowtypes={fieldshowtypes}
                    value={value1}
                    onChange={bindObj.onChange}
                    {...layoutProps}
                    supportCancel
                />
                <span className="editicon"><i className="icon-coms-edit" ></i></span>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/excel-layout/cell-field/select-element/index.tsx